<template>
  <b-row class="features">
    <b-col
      v-for="(feature, feature_index) in features"
      :key="feature.icon"
      md="6"
      lg="3"
      :class="'features__element features__element--' + feature_index"
    >
      <feature-card
        :icon="feature.icon"
        :title="feature.title"
        :text="feature.text"
        :title_size="14"
        :background_color="feature.background_color"
        :icon_background_color="feature.icon_background_color"
        icon_color="#fff"
      />
    </b-col>
  </b-row>
</template>

<script>
  import { VALIDITY_MONTHS } from '@livegift/resources';

  export default {
    name: 'livegift-features',

    data() {
      return {
        features: [
          {
            icon: 'globe',
            title: 'Offerta globale',
            text: 'Valida per migliaia di strutture e servizi di viaggio in tutto il mondo.',
            background_color: 'rgba(0, 188, 125, .1)',
            icon_background_color: 'linear-gradient(135deg, #00d492, #00bba7)',
          },
          {
            icon: 'bolt',
            title: 'Zero fretta',
            text: `Hai ${VALIDITY_MONTHS} mesi di tempo dall'acquisto per prenotare.`,
            background_color: 'rgba(254, 154, 0, .1)',
            icon_background_color: 'linear-gradient(135deg, #ffb900, #ff6900)',
          },
          {
            icon: 'wallet',
            title: 'Integrazione con carta',
            text: 'Puoi integrare la differenza con carta di credito.',
            background_color: 'rgba(0, 166, 244, .1)',
            icon_background_color: 'linear-gradient(135deg, #00bcff, #2b7fff)',
          },
          {
            icon: 'cursor-click',
            title: 'Assistenza Top',
            text: 'Hai a disposizione un Customer Care tra i migliori del settore.',
            background_color: 'rgba(142, 81, 255, .1)',
            icon_background_color: 'linear-gradient(135deg, #a684ff, #f6339a)',
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>

  .features {
    padding: 0 0 ($grid-gutter-width / 2);
    border-radius: $border-radius-lg * 2;
    box-shadow: 0 10px 7.5px rgba(#615FFF, .05);

    @include media-breakpoint-down(sm) {
      margin: 0;
    }

    &__element {
      margin-bottom: $grid-gutter-width / 2;

      &:last-child {
        margin-bottom: 0;
      }

      @include media-breakpoint-up(md) {
        margin-bottom: 0;
      }

      @include media-breakpoint-down(md) {
        &:nth-child(-n+2) {
          margin-bottom: $grid-gutter-width / 2;
        }
      }
    }
  }
</style>